import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';

const requestPasswordResetDataSchema = z.object({
  email: z.string().trim().min(1, 'Email is required.').email('Enter a valid email address.'),
});

/** Form values for request-reset; `redirectTo` is added by the form/page, not the user. */
export type RequestPasswordResetFormValues = {
  email: string;
};

export class RequestPasswordResetDataValidator
  implements Validator<RequestPasswordResetFormValues>
{
  readonly standardSchema = requestPasswordResetDataSchema;

  validate(value: unknown): Result<RequestPasswordResetFormValues, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Invalid request-password-reset payload.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
